import { HStack, Text } from "@chakra-ui/react";
import * as React from "react";
import { FiInfo } from "react-icons/fi";

interface InfoProps {
  children: React.ReactNode;
  className?: string;
}

export function Info({ children, ...props }: InfoProps) {
  return (
    <HStack
      bg="gray.100"
      borderRadius="sm"
      fontSize="xs"
      gap="2"
      p="2"
      {...props}
    >
      <Text color="green.600">
        <FiInfo />
      </Text>
      <Text color="fg.muted">{children}</Text>
    </HStack>
  );
}
